/** @readonly */
export const SELECT_MODE = Object.freeze({
  STATIC: 'static',
  INFINITE: 'infinite',
});
